<template>
  <div>
    <template v-if="!appLoaded || appLoading">
      <div class="center-loading">
        <spinner />
      </div>
    </template>
    <template v-else>
      <router-view />
    </template>
  </div>
</template>

<script>
  import TranslationHelper from '@/helpers/translation.helper';
  import StorageService from '@/services/storage.service';
  import {
    mapActions, mapGetters, mapMutations, mapState,
  } from 'vuex';

  export default {
    name: 'App',
    computed: {
      ...mapGetters(['appLoading']),
      ...mapGetters('data', ['languages']),
      ...mapState('translation', ['translatedLanguages']),
    },
    methods: {
      ...mapActions('data', ['fetchLanguages']),
      ...mapMutations('user', ['setLang']),
    },
    data() {
      return {
        appLoaded: false,
      };
    },
    async beforeCreate() {
      const element = document.getElementById('appLoading');
      element.style.display = 'none';
    },
    async beforeMount() {
      const router = this.$router;
      await this.fetchLanguages();
      await TranslationHelper.updateTranslations(router, StorageService.getLang());
      const langQuery = this.$route.query.lang;
      const langParam = this.$route.params.lang;
      const lang = langQuery || langParam;
      if (lang && this.languages.find((item) => item.code === lang)) {
        this.setLang(lang);
      }
      this.appLoaded = true;
    },
  };
</script>
